import { Form, Input } from "antd";
import {
  validateEmail,
  getConfigAppPartType,
  validateUrl,
  validatePhone,
} from "@lhd/features/Apps/utils";
import { AppPartType } from "@lhd/features/Apps/AppForm/types";
import { Styles } from "./style";
import { getRuleValidation } from "@lhd/components/CloneApp/fieldUtils";
interface IProps {
  item: AppPartType;
  namePath: string | string[];
}

const LinkCusTom = (props: IProps) => {
  const { item, namePath } = props;

  const form = Form.useFormInstance();
  const value = form.getFieldValue(namePath);
  const { link_type } = item.item_config_data;
  let href = value; // link_type = url
  if (link_type == "phone_number") href = "tel:" + value;
  else if (link_type === "email") href = "mailto:" + value;

  return (
    <Styles>
      <Form.Item
        name={namePath}
        rules={[
          ...getRuleValidation(item),
          ...(link_type === "url" || !link_type
            ? [
                {
                  message:
                    "URL 形式が無効です。URLは「http://」また「https://」で開始する必要があります。",
                  validator: (_: any, value: string) => {
                    if (!value || validateUrl(value)) {
                      return Promise.resolve();
                    } else {
                      return Promise.reject("fail");
                    }
                  },
                },
              ]
            : []),
          ...(link_type === "email"
            ? [
                {
                  message:
                    "メールアドレス形式は無効です。例：username@example.comの形でお願いいたします。",
                  validator: (_: any, value: string) => {
                    if (validateEmail(value) || !value) {
                      return Promise.resolve();
                    } else {
                      return Promise.reject("fail");
                    }
                  },
                },
              ]
            : []),
          ...(link_type === "phone_number"
            ? [
                {
                  message: "このフィールドは数字のみを受け付けます",
                  validator: (_: any, value: string) => {
                    if (!item.is_required_field && value === undefined)
                      return Promise.resolve();
                    if (validatePhone(value) || !value) {
                      return Promise.resolve();
                    } else {
                      return Promise.reject("fail");
                    }
                  },
                },
              ]
            : []),
        ]}
      >
        <Input onPressEnter={(e) => e.preventDefault()} />
      </Form.Item>
    </Styles>
  );
};
export default LinkCusTom;
